import { Box, ToggleButton, ToggleButtonGroup, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

const BLOOD_TYPES = ['A+', 'A-', 'B+', 'B-', 'AB+', 'AB-', 'O+', 'O-'] as const;
export type BloodType = (typeof BLOOD_TYPES)[number];

interface Props {
  value: BloodType | null;
  onChange: (v: BloodType | null) => void;
  label?: string;
  error?: string;
}

export default function BloodTypePicker({ value, onChange, label, error }: Props) {
  const { t } = useTranslation();

  return (
    <Box>
      {label && (
        <Typography variant="body2" fontWeight={600} mb={1} color={error ? 'error' : 'text.secondary'}>
          {label || t('register.blood_type')}
        </Typography>
      )}
      <ToggleButtonGroup
        value={value}
        exclusive
        onChange={(_, v) => onChange(v as BloodType | null)}
        sx={{ flexWrap: 'wrap', gap: 1 }}
      >
        {BLOOD_TYPES.map((bt) => (
          <ToggleButton
            key={bt}
            value={bt}
            sx={{
              minWidth: 64,
              fontWeight: 700,
              fontSize: '1rem',
              borderRadius: '10px !important',
              border: '2px solid',
              borderColor: 'divider',
              '&.Mui-selected': {
                bgcolor: 'primary.main',
                color: 'white',
                borderColor: 'primary.main',
                '&:hover': { bgcolor: 'primary.dark' },
              },
            }}
          >
            {bt}
          </ToggleButton>
        ))}
      </ToggleButtonGroup>
      {error && (
        <Typography variant="caption" color="error" mt={0.5} display="block">
          {error}
        </Typography>
      )}
    </Box>
  );
}
